import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { FaTrash } from "react-icons/fa";
import { ToDoListService } from "../../services/ToDoListService";
import { toast } from "react-toastify";
import AddNewTodo from "../../Modal/AddNewTodo";
import { RiTodoLine } from "react-icons/ri";

const ToDoList = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const formattedSelectedDate = new Date(selectedDate).toLocaleDateString(
    "en-GB",
    {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }
  );

  useEffect(() => {
    const fetchList = async () => {
      try {
        const response = await ToDoListService.getToDoList(selectedDate);
        if (response) {
          setList(response.data);
        }
      } catch (error) {
        toast.error(error?.message || "Failed to fetch tasks");
      }
    };
    fetchList();
  }, [selectedDate]);

  const handleDelete = async (id) => {
    try {
      const response =await ToDoListService.deleteToDo(id);
      if (response) {
        toast.success("Task deleted successfully");
        setList((prev)=>prev.filter((item)=> item.id !== id));
      }
    } catch (error) {
      toast.error(error?.message || "Failed to delete task");
    }
  };

  const handleStatusChange = async (id) => {
    try {
      const response = await ToDoListService.updateStatus(id);

      if (response) {
        setList((prev) =>
          prev.map((item) =>
            item.id === id
              ? { ...item, isCompleted: !item.isCompleted }
              : item
          )
        );
        toast.success(response.message || "List updated successfully..")
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update status");
    }
  };

  return (
    <div className="w-full h-[40vh] p-5 rounded-xl shadow-lg bg-white border border-gray-200">
      {/* Header */}
      <div className="flex flex-wrap gap-3 justify-between items-center mb-5">

        <h1 className="font-bold text-lg bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent flex items-center gap-2">
          <RiTodoLine className="text-blue-700 text-xl" /> Todo List
        </h1>

        <div className="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-start">

          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none "
          />
          <button
            onClick={() => setShowModal(true)}
            className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-full w-9 h-9 flex items-center justify-center text-lg shadow hover:from-blue-700 hover:to-indigo-700 transition"
          >
            <FaPlus />
          </button>
        </div>
      </div>

      {/* Selected Date */}
      <h2 className="text-sm text-gray-600 mb-3">
        List for:{" "}
        <span className="font-medium text-gray-800">
          {formattedSelectedDate}
        </span>
      </h2>

      {/* Todo List */}
      <div
        className="mt-3 h-[20vh] overflow-y-auto pr-1 space-y-2"
        style={{ scrollbarWidth: "none" }}
      >
        <ul className="space-y-2">
          {list.length === 0 ? (
            <li className="text-gray-500 italic">
              No list found for {formattedSelectedDate}
            </li>
          ) : (
            list.map((item, ind) => (
              <li
                key={item.id}
                className="flex justify-between items-center bg-gray-50 p-2 rounded-lg shadow-sm hover:shadow-md transition gap-1"
              >
                <span className="flex-1 text-gray-800">
                  {ind + 1}
                  {"]"} {item.task}
                </span>

                <input
                  type="checkbox"
                  checked={item.isCompleted}
                  onChange={() => handleStatusChange(item.id)}
                  className="w-4 h-4 accent-green-600 cursor-pointer"
                />

                <button
                  onClick={() => handleDelete(item.id)}
                  className="text-red-500 hover:text-red-600 p-1 rounded-full hover:bg-red-50 transition"
                >
                  <FaTrash />
                </button>
              </li>
            ))
          )}
        </ul>
      </div>

      {/* Modal */}
      {showModal && (
        <AddNewTodo onClose={() => setShowModal(false)} setList={setList} />
      )}
    </div>
  );
};

export default ToDoList;
